module.exports = __webpack_public_path__ + "static/img/wx_gzh.9fcac99.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/commonRankBoard/assets/wx_gzh.png
// module id = R6OK
// module chunks = 3